import { create } from 'zustand';
import { executeDelete, executeFetch, executePost } from '../helper/Api';
import Cookies from 'js-cookie';
import { Favourite } from '../types/Favourite';


interface StoreState {
  favourites: Favourite[]; 
  getUserFavourites : () => void;
  addFavourite: (cartItem: Favourite) => void;
  removeFavourite: (id: string) => void;
}


const useFavouriteStore = create<StoreState>((set) => ({
  favourites: [],
  getUserFavourites: async () => {
    const hasToken = Cookies.get('token') !== undefined;
    if(hasToken){
    try {
        const resp = await executeFetch<Favourite[]>(`Customer/GetUserFavourites`,{auth:'auth'})
      if(resp.error){
          console.error(resp.error.message)
      }else{
        set({ favourites: resp.data as Favourite[]});
      }
    } catch (error) {
      console.error("Error fetching favourites:", error);
      
    }
  }else{
    set({ favourites: [] as Favourite[]});
  }
  },
  addFavourite: async (newItem: Favourite) => {
    try {
        const resp = await executePost<Favourite, Favourite>(
          `Customer/AddFavourite`,
          newItem,
          { auth: 'auth' }
        );
  
        if (resp.error) {
          console.error(resp.error.message);
        } else {
          set((state) => ({
            ...state,
            favourites: [...state.favourites, resp.data],
          }));
        }
    
    } catch (error) {
      console.error("Error adding cart item:", error);
      throw error;
    }
  },
  removeFavourite: async (id : string) =>{
    try{
  const resp = await executeDelete(`Customer/DeleteFavourite`,id,{auth:'auth'})
  if(resp.error){
    console.error(resp.error.message)
  }else{
    set((state) => ({
      ...state,
      cart: state.favourites.filter(item => item.id !== id)
    }));
  }
} catch (error) {
  console.error("Error deleting cart item:", error);
  throw error;
}
}

}));

export default useFavouriteStore;